export const environment = {
  userManagementBaseUrl: 'https://stgtw.coure-tech.com/anq-user-mgt',
  cmsBaseUrl: 'https://stgtw.coure-tech.com/anq-cms',
  apiDocBaseUrl: 'https://stgtw.coure-tech.com/anq-docs',

  // Billing base URLs
  billingAccountServiceBaseUrl: 'https://stgtw.coure-tech.com/billing-account',
  billingInvoiceBaseUrl: 'https://stgtw.coure-tech.com/billing-invoice',

  // Routing base URLs
  routingService: 'https://stgtw.coure-tech.com/anqapi',
  mnpHistoryBaseUrl: 'https://stgtw.coure-tech.com/coure-mnphistory-api',

  // KYC base URLs
  kycAccountBaseUrl: "https://stgtw.coure-tech.com/kyc-account",
  kycBvnBaseUrl: "https://stgtw.coure-tech.com/kyc-bvn",
  kycCacBaseUrl: "https://stgtw.coure-tech.com/kyc-cac",
  kycCalleridBaseUrl: "https://stgtw.coure-tech.com/kyc-callerid",
  kycCustomerBaseUrl: "https://stgtw.coure-tech.com/kyc-customer",
  kycDriversBaseUrl: "https://stgtw.coure-tech.com/kyc-drivers",
  kycNinBaseUrl: "https://stgtw.coure-tech.com/kyc-nin",
  kycNumberBaseUrl: "https://stgtw.coure-tech.com/kyc-number",
  kycPassportBaseUrl: "https://stgtw.coure-tech.com/kyc-passport",
  kycTinBaseUrl: "https://stgtw.coure-tech.com/kyc-tin",
  kycVoterscardBaseUrl: "https://stgtw.coure-tech.com/kyc-voterscard",

  // Fraud prevention base URLs
  fpSimSwapCamaraBaseUrl: 'https://stgtw.coure-tech.com/fraudprevention-simswap-camara',
  fpSimRecycleCamaraBaseUrl: 'https://stgtw.coure-tech.com/fraudprevention-simrecycling-camara',
  fpSimswapBaseUrl: 'https://stgtw.coure-tech.com/simswap',
  fpActiveStatusBaseUrl: 'https://stgtw.coure-tech.com/activestatus',
  fpSimAgeBaseUrl: 'https://stgtw.coure-tech.com/simage',
  fpNumberActivityBaseUrl: 'https://stgtw.coure-tech.com/numberactivity',
  fpSimRecycleBaseUrl: 'https://stgtw.coure-tech.com/simrecycle',
  fpDeviceInfoBaseUrl: 'https://stgtw.coure-tech.com/deviceinfo',
  fpSimActiveStatusBaseUrl: 'https://stgtw.coure-tech.com/activestatus',

  sftpBaseUrl: 'https://stgtw.coure-tech.com/sftp-api',
  consentBaseUrl: 'https://stgtw.coure-tech.com/consent',
  otpBaseUrl: 'https://stgtw.coure-tech.com/anq-otp',

  // Versions and keys
  anqCmsVersion: '2.0',
  apiDocVersion: '1.0',
  xKey: 'canqTXQvwOe0DRy4oaabOdejNpoSS0cj9YK3p49dvMtfNNkAT1pfQjXsgkK2947d9O4fvw3bLeq7xCP5AAxdDYvL5nJt5Ld89zDEmGBp52sZGNybvkV1uwz4N4uxtgZ0A5iBW1BHvDXltqE9i4n8spZhgqLSCtVt4OrquypRcAEftvy8bPy7egsRUKmExi8dHnaCOiVnUrzqL8TgE3ZUK5B8QjFEqbpoLQHA95OzXQIAmw5af8PxCs8ejlCLloNL',
  
  // Meta
  environmentName: 'staging',
  production: true,
  appVersion: 'v8.1.0'
};
  